import React from "react";
import "./DashboardHeader.scss";
import ContractsSelect from "../../common/ContractsSelect/ContractsSelect";
import ContactSecondary from "../../common/ContactSecondary/ContactSecondary";
import ArrowLink from "../../common/ArrowLink/ArrowLink";
import { useTranslation } from "react-i18next";
import { UserRoleEnum } from "../../../helpers/enums";
import {useSelector} from "react-redux";
const InfoSelectedContractMetre = (props) => {
  const { t } = useTranslation();
  return props.metre ? (
    <div className="row meter-container">
      <h2 className={`col-sm-12 headline-fs5 ${"dati_contatore"}`}>
        {t("dashboard.header.info.metre.title")}
      </h2>
      <div className="row meter-specs col-sm-12">
        <div className="col-sm-12 col-md-6">
          <h3 className="paragraph-small-fs9">
            {t("dashboard.header.info.metre.col1")}
          </h3>
          <span className="paragraph-large-fs7">{props.metre.serialNumber ?? t("dashboard.header.info.meter.not.available")}</span>
        </div>
        <div className="col-sm-12 col-md-6">
          <h3 className="paragraph-small-fs9">
            {t("dashboard.header.info.metre.col2")}
          </h3>
          <span className="paragraph-large-fs7">{props.metre.location ?? t("dashboard.header.info.meter.not.available")}</span>
        </div>
        <div className="col-sm-12 col-md-6">
          <h3 className="paragraph-small-fs9">
            {t("dashboard.header.info.metre.col3")}
          </h3>
          <span className="paragraph-large-fs7">{props.metre.diameter ?? t("dashboard.header.info.meter.not.available")}</span>
        </div>
        <div className="col-sm-12 col-md-6 info-text-box">
          <h3 className="paragraph-small-fs9">
            {t("dashboard.header.info.metre.col4")}
          </h3>
          <span className="paragraph-large-fs7">{props.metre.indicesNumber ?? t("dashboard.header.info.meter.not.available")}</span>
        </div>
      </div>
    </div>
  ) : null;
};

const getInfoComponent = (role, { metre }) => {
  const info = {
    [UserRoleEnum.PRIVATE]: <InfoSelectedContractMetre metre={metre} />,
    [UserRoleEnum.COMPANY]: <InfoSelectedContractMetre metre={metre} />,
    [UserRoleEnum.MUNICIPAL_USER]: <InfoSelectedContractMetre metre={metre} />,
    [UserRoleEnum.CONDOMINIUM_ADMIN]: null,
    [UserRoleEnum.OPERATOR]: null,
    [UserRoleEnum.MANAGER]: null,
    [UserRoleEnum.MUNICIPAL_OPERATOR]: null,
    [UserRoleEnum.PARTNER]: null,
  };
  return info[role];
};

const DashboardHeader = (props) => {
  const { t } = useTranslation();
  const { userProfile } = props;
  const loggedWith = useSelector((state) => state.auth.auth_issuer)
  const profileImage =
    userProfile && userProfile.profilePicture
      ? userProfile.profilePicture
      : null;
  return (
    <section className="DashboardHeader" data-testid="DashboardHeader">
      <div className="container">
        <div className="row">
          <ContactSecondary>
            <div className={"contact-card__image text-center"}>
              {profileImage ? (
                <img src={profileImage} alt="" />
              ) : (
                <div className="avatar-placeholder">
                  <i
                    className="gc-icon-functional-profile-2-col"
                    aria-hidden="true"
                  >
                    <span className="path1" />
                  </i>
                </div>
              )}
              <span />
            </div>
            <div className="contact-card-stats-box d-flex flex-column justify-content-center">
              <div className="user-data-box">
                <div className="greeting">{t("dashboard.greeting")},</div>
                <div className="greeting-username">
                    {userProfile.name} {userProfile.surname}
                </div>
              </div>
              {userProfile.fiscalCode ? (
                <span className="contact-card-stats-box--role">{userProfile.fiscalCode} - {props.contracts.length} {t("dashboard.associatedContracts")}</span>
              ) : null}
              <div className="contact-card-contacts d-flex justify-content-center">
                <ArrowLink to={"/user-profile"}>
                  {t("common.modifyUserData")}
                </ArrowLink>
                {loggedWith=== "COGNITO" ? <ArrowLink to={"/change-password"}>
                  {t("common.changePassword")}
                </ArrowLink>: null}
                {/*<ArrowLink to={'/master'}>Master</ArrowLink>*/}
              </div>
            </div>
          </ContactSecondary>
          <div className="contract-select-container col-sm-12 col-md-6">
            <div className="contract-select">
              <h2 className="headline-fs5 mb-4">{t("dashboard.contractSelect")}</h2>
              <ContractsSelect />
            </div>
            {getInfoComponent(userProfile.role, props)}
          </div>
        </div>
      </div>
    </section>
  );
};

DashboardHeader.propTypes = {};

export default DashboardHeader;
